module.exports = __webpack_public_path__ + "static/img/videoImage.8c6bc84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/videoImage.png
// module id = 6TmK
// module chunks = 0